"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var config_1 = require("../../config");
var styles = {
    img: { width: "100%", height: "auto" },
};
var PageQR = react_1.default.memo(function (_a) {
    var page = _a.page;
    if (!page)
        return react_1.default.createElement("div", null);
    var pageURL = "".concat(config_1.APP_BASE_URL, "/pages/").concat(page.id);
    return react_1.default.createElement("div", null,
        react_1.default.createElement("img", { src: "".concat(config_1.API_BASE_URL, "/pages/").concat(page.id, "/qr"), style: styles.img, alt: "Page QR: ".concat(page.title) }),
        react_1.default.createElement("a", { href: pageURL }, pageURL));
});
exports.default = PageQR;
